'use client';
import { Text, Box, Image, Center, Grid, Button } from '@chakra-ui/react';
import React from 'react';

function Breakdown() {
  const heading = {
    fontSize: { base: '6vw', md: '2vw' },
    fontWeight: 700,
    color: 'white',
  };
  const headText = {
    fontSize: { base: '4vw', md: '1vw' },
    textAlign: 'center',
    color: 'white',
    padding: { base: '0 0 5vw', md: '0' },
  };
  const handleScrollUp = () => {
    // Scroll the page up by the height of the hero container
    const packagesSection = document.getElementById('packages');
    if (packagesSection) {
      packagesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const container = {
    bg: '#2e2925',
    color: '#ffffff',
    padding: '3vw 0',
  };
  const gridBox = {
    bg: 'none',
    textAlign: 'center',
    templateColumns: { base: '1fr', md: '1fr 1fr 1fr' },
    gap: { base: '5vw', md: '1.5vw' },
    margin: '3vw 6vw 0',
  };
  const gridItem = {
    display: 'grid',
    gridTemplateColumns: '1fr', // 1 column
    gridTemplateRows: { base: '6fr 3fr', md: '6fr 4fr' }, // 2 rows
    width: '100%',
    height: { base: '580px', md: 'auto' },
  };

  const gridImg = {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    maxWidth: '100%',
    opacity: '100%',
    gridRow: '1 / span 2',
    gridColumn: '1',
    borderRadius: { base: '6vw', md: '2.5vw' },
  };
  const gridTitle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'end',
    textAlign: 'center',
    fontSize: { base: '6vw', md: '2vw', lg: '2vw' },
    fontWeight: '700',
    gridRow: '1',
    gridColumn: '1',
  };
  const gridText = {
    display: 'grid',
    gridTemplateRows: '3fr 2fr',
    alignItems: 'start',
    textAlign: 'center',
    padding: { base: '3vw 5vw', md: '1vw 4vw', lg: '1vw 3vw' },
    gridRow: '2',
    gridColumn: '1',
    lineHeight: { base: '5vw', md: '1.2vw', lg: '1.2vw' },
    fontSize: { base: '4vw', md: '1.2vw', lg: '0.9vw' },
  };
  const buttonSelect = {
    width: '100%',
    borderRadius: { base: '6vw', md: '2.5vw' },
    bgColor: '#ffffff',
    color: '#666',
    alignSelf: 'end',
    fontSize: { base: '4.4vw', md: '1.2vw', lg: '1.2vw' },
    fontWeight: 600,
    padding: { base: '6vw 0', md: '1.5vw 0' },
    _hover: {
      cursor: 'pointer', // Correct hover effect for the button
      bgColor: 'rgba(235, 235, 235, 0.5)',
    },
    marginTop: { base: '3vw', md: '0' },
  };
  return (
    <Box {...container}>
      <Center {...heading}>How easy is it to order?</Center>
      <Center {...headText}>
        We've outlined a step-by-step for your convenience.
      </Center>
      <Grid {...gridBox}>
        <Box {...gridItem}>
          <Image
            {...gridImg}
            src="/images/gym/process-3x4-range.jpg"
            alt="Survey Image"
            objectFit="cover" // Optional: Ensures the image covers the container without distortion
            width="100%" // Optional: Set the width of the image
            height={{ base: '580px', md: 'auto' }} // Optional: Set the height of the image
          />
          <Box {...gridTitle}>
            <Text>Select a Size</Text>
          </Box>
          <Box {...gridText}>
            <Text>
              We have standard sizes ready to go, but we'd love to chat if
              you're looking for something custom!
            </Text>
            <Center>
              <Button {...buttonSelect} onClick={handleScrollUp}>
                Get Started
              </Button>
            </Center>
          </Box>
        </Box>
        <Box {...gridItem}>
          <Image
            {...gridImg}
            src="/images/gym/install-3x4-delivery.jpg"
            alt="Mirrorworld Gym Mirrors Our production"
            objectFit="cover" // Optional: Ensures the image covers the container without distortion
            width="100%" // Optional: Set the width of the image
            height={{ base: '580px', md: 'auto' }} // Optional: Set the height of the image
          />
          <Box {...gridTitle}>
            <Text>Schedule a Delivery</Text>
          </Box>
          <Box {...gridText}>
            <Text>
              Use our online system to organise a time and date. Our service
              covers the UK, whether you're located in a bustling city centre or
              a remote countryside location.
            </Text>
            <Center>
              <Button {...buttonSelect} onClick={handleScrollUp}>
                Book Now
              </Button>
            </Center>
          </Box>
        </Box>
        <Box {...gridItem}>
          <Image
            {...gridImg}
            src="/images/gym/install-3x4-fitting-v2.jpg"
            alt="Mirrorworld Gym Mirrors safety Backing"
            objectFit="cover" // Optional: Ensures the image covers the container without distortion
            width="100%" // Optional: Set the width of the image
            height={{ base: '580px', md: 'auto' }} // Optional: Set the height of the image
          />
          <Box {...gridTitle}>
            <Text>Sit Back, We Install</Text>
          </Box>
          <Box {...gridText}>
            <Text>
              Let us give you a stress-free process and handle installation from
              start to finish, whether it's for your home or a commercial space.
            </Text>
            <Center>
              <Button {...buttonSelect} onClick={handleScrollUp}>
                See our Packages
              </Button>
            </Center>
          </Box>
        </Box>
      </Grid>
    </Box>
  );
}
export default Breakdown;
